import type {FileApiModel} from '../../../api/media/file';

const LOGO_SIZES = [60, 120, 180, 340] as const;

export const getSupportLogoFile = (size: (typeof LOGO_SIZES)[number]) => {
  const _size = LOGO_SIZES.includes(size)
    ? size
    : LOGO_SIZES[LOGO_SIZES.length - 1];

  return {
    _id: 'file:support-logo',
    categories: [],
    src: {
      original: {
        filename: 'SupportLogo',
        mimetype: 'image/png',
        size: 0,
        url: `https://assets.yourcoach.health/support_${_size}x${_size}.png`,
      },
    },
  } as unknown as FileApiModel;
};
